<template>
  <span v-if="placeholder">
    <slot>{{ link.label }}</slot>
  </span>
  <NuxtLink
    v-else-if="route"
    v-bind="{ to: route, ...(link.target_blank && TARGET_BLANK) }"
  >
    <slot>
      {{ link.label }}
    </slot>
  </NuxtLink>
  <a v-else :href="href" v-bind="{ ...(link.target_blank && TARGET_BLANK) }">
    <slot>
      {{ link.label }}
    </slot>
  </a>
</template>

<script lang="ts" setup>
import type { PublicLink, AnchorTypeEnum } from '@/service/__generated-api'

const props = defineProps<{
  link: PublicLink
  placeholder?: boolean
}>()

const TARGET_BLANK = { target: '_blank', rel: 'noopener noreferrer' }

const href = computed(() =>
  props.link.anchor_type === 'attachment'
    ? props.link.attachment_file
    : props.link.anchor_type === 'url'
    ? props.link.url
    : ''
)

const route = computed(() => {
  const { anchor_type, slug, widget } = props.link
  const isHomePage = slug === 'home'

  const routeNameByType: Partial<Record<AnchorTypeEnum, string>> = {
    simplepage: isHomePage ? 'index' : 'slug',
    article: 'blog-slug',
    courseandeventpage: 'course-slug'
  }

  const name = routeNameByType[anchor_type]

  if (name) {
    const params: undefined | { slug: string } = isHomePage
      ? undefined
      : { slug }
    const hash = (widget && `#widget-${widget}`) ?? ''

    return useLocalePath()({ name, params, hash })
  }

  return
})
</script>
